// Local development configuration
export const LOCAL_CONFIG = {
  // Disable authentication for local development
  DISABLE_AUTH: true,
  
  // Use mock API endpoints
  USE_MOCK_API: true,
  
  // Local API base URL (if you want to run a local backend)
  LOCAL_API_BASE_URL: 'http://localhost:3001',
  
  // Mock user data
  MOCK_USER: {
    uid: 'local-user-123',
    login: 'localuser',
    fullName: 'Local Development User',
    email: 'local@example.com',
    department: 'Development',
    isActive: true
  },
  
  // Mock bookmarks data
  MOCK_BOOKMARKS: [
    {
      id: '1',
      title: 'React Documentation',
      url: 'https://reactjs.org/docs',
      description: 'Official React documentation',
      tags: ['react', 'javascript', 'frontend'],
      createdBy: 'localuser',
      createdAt: new Date().toISOString(),
      isFavorite: true
    },
    {
      id: '2',
      title: 'TypeScript Handbook',
      url: 'https://www.typescriptlang.org/docs/',
      description: 'Complete TypeScript reference',
      tags: ['typescript', 'javascript'],
      createdBy: 'localuser',
      createdAt: new Date().toISOString(),
      isFavorite: false
    },
    {
      id: '3',
      title: 'Redux Toolkit',
      url: 'https://redux-toolkit.js.org/',
      description: 'The official, opinionated, batteries-included toolset for efficient Redux development',
      tags: ['redux', 'state-management', 'react'],
      createdBy: 'localuser',
      createdAt: new Date().toISOString(),
      isFavorite: true
    }
  ]
};

// Check if we're in local development mode
export const isLocalDevelopment = () => {
  return window.location.hostname === 'localhost' || 
         window.location.hostname === '127.0.0.1' ||
         window.location.hostname.includes('local');
};
